import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {API_HOST, BIN_JWT_TOKEN, BIN_REFRESH_TOKEN } from '../../config/config';

import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer/Footer";

async function login(email, password) {
	try {
		const response = await fetch(`${API_HOST}auth/login`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({email, password}),
		});

		if (response.status === 401 || response.status === 500 ) {
		  const error = await response.json();
		  throw new Error( error.exception);
    }

		return await response.json();
	} catch (error) {
		console.error('Error:', error);
	}
}

async function verifyOtp(pre2faToken, otpCode) {
	try {
		const response = await fetch(`${API_HOST}auth/verify_otp`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({pre_2fa_token: pre2faToken, otp_code: otpCode}),
		});

		const data = await response.json();

		if (response.status === 401) {
			throw new Error(data.message || 'Verifizierung fehlgeschlagen');
		}

		return data;
	} catch (error) {
		throw error;
	}
}

function LoginLayout() {
	const [email, setEmail] = useState([]);
	const [password, setPassword] = useState([]);
	const [hasError, setHasError] = useState(false);
	const [step, setStep] = useState('credentials');
	const [otpCode, setOtpCode] = useState('');
	const [pre2faToken, setPre2faToken] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const navigate = useNavigate();

	const updateEmail = (event) => {
		setEmail(event.target.value);
	}

	const updatePassword = (event) => {
		setPassword(event.target.value);
	}

	const onSubmit = () => {
		(async () => {
      try {
        if (email.length === 0 || password.length === 0) {
          setHasError(true);
          return;
        }

        const result = await login(email, password);
        if (result && result.token) {
          localStorage.setItem(BIN_JWT_TOKEN, result.token);
          if (result.refresh_token) {
            localStorage.setItem(BIN_REFRESH_TOKEN, result.refresh_token);
          }
          const return_to = sessionStorage.getItem('return_to');
          if (return_to) {
            sessionStorage.removeItem('return_to');
            window.location.href = return_to;
          } else {
            navigate(`/`);
          }
        } else if (result && result.requires_2fa) {
          setPre2faToken(result.pre_2fa_token);
          setStep('otp');
          setHasError(false);
          setErrorMessage('');
        } else {
          setHasError(true);
        }
      } catch (error) {
        console.error('Error:', error);
        setHasError(true);
      }
		})();
	}

	const onOtpSubmit = () => {
		(async () => {
			try {
				if (otpCode.length !== 6) {
					setErrorMessage('Bitte geben Sie den 6-stelligen Code ein.');
					return;
				}

				const result = await verifyOtp(pre2faToken, otpCode);
				if (result && result.token) {
					localStorage.setItem(BIN_JWT_TOKEN, result.token);
					if (result.refresh_token) {
						localStorage.setItem(BIN_REFRESH_TOKEN, result.refresh_token);
					}
					const return_to = sessionStorage.getItem('return_to');
					if (return_to) {
						sessionStorage.removeItem('return_to');
						window.location.href = return_to;
					} else {
						navigate(`/`);
					}
				}
			} catch (error) {
				setErrorMessage(error.message || 'Verifizierung fehlgeschlagen');
			}
		})();
	}

	const onBackToLogin = () => {
		setStep('credentials');
		setOtpCode('');
		setPre2faToken('');
		setErrorMessage('');
		setHasError(false);
	}

	return (
		<>
      <PublicHeader/>

      <div className="container-xxl bg-white text-bg-light mt-5 py-4">
        <div className="row">
          <div className="col">
            <h2 className="mb-4">Login</h2>
          </div>
        </div>

        <div className="row">
          <div className="col">
            {step === 'credentials' && (
              <>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">E-Mail</label>
                  <input type="email" className={`form-control ${hasError ?  `is-invalid` : '' }`} id="email" value={email} onChange={updateEmail}/>
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Passwort</label>
                  <input className={`form-control ${hasError ?  `is-invalid` : '' }`} name="password" type="password" id="password" value={password} onChange={updatePassword}/>
                  {hasError &&
                    <div className="invalid-feedback">
                      Ihre Zugangsdaten scheinen nicht korrekt zu sein.
                    </div>
                  }
                </div>
                <div className="py-3">
                  <button type="button" className="btn btn-primary" onClick={onSubmit} >Anmelden</button>
                  <a className="px-4" href="/password/forgot">Passwort zurücksetzen</a>
                </div>
              </>
            )}

            {step === 'otp' && (
              <>
                <p>Wir haben Ihnen einen 6-stelligen Code per E-Mail gesendet.</p>
                <div className="mb-3">
                  <label htmlFor="otp_code" className="form-label">Anmeldecode</label>
                  <input
                    type="text"
                    className={`form-control ${errorMessage ? 'is-invalid' : ''}`}
                    id="otp_code"
                    value={otpCode}
                    maxLength="6"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="one-time-code"
                    onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                  />
                  {errorMessage &&
                    <div className="invalid-feedback">
                      {errorMessage}
                    </div>
                  }
                </div>
                <div className="py-3">
                  <button type="button" className="btn btn-primary" onClick={onOtpSubmit}>Bestätigen</button>
                  <button type="button" className="btn btn-link px-4" onClick={onBackToLogin}>Zurück zum Login</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Footer/>
    </>
  )
}

export default LoginLayout;
